//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Product from "./Product.vue";
export default {
  name: "Products",
  components: {
    Product: Product
  },
  data: function data() {
    return {
      activeSubCategory: null,
      products: this.activeCategory ? this.activeCategory.items : null,
      subCategories: this.activeCategory ? this.activeCategory.subCategories : null
    };
  },
  watch: {
    activeCategory: function activeCategory(category) {
      this.products = category ? category.items : null;
      this.subCategories = category ? category.subCategories : null;
    }
  },
  props: {
    shoppingCard: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      required: true
    }
  }
};